const CREATE_CONTENT_GROUP = "content-groups::create";
const CREATE_CONTENT_GROUP_ERROR = "content-groups::create::error";
const CREATE_CONTENT_GROUP_SUCCESS = "content-groups::create::success";

const LOAD_CONTENT_GROUPS = "content-groups::load-all::success";
const LOAD_CONTENT_GROUPS_FAILURE = "content-groups::load-all::failure";

const EDIT_CONTENT_GROUP = "content-groups::edit";
const EDIT_CONTENT_GROUP_ERROR = "content-groups::edit::error";
const EDIT_CONTENT_GROUP_SUCCESS = "content-groups::edit::success";

const ARCHIVE_CONTENT_GROUPS_SUCCESS = "content-groups::archive::success";

function editContentGroupAction(payload, successMessage = "") {
  const { id, name, content } = payload;
  return {
    payload: {
      successMessage,
      serviceArgs: [id, name, content],
    },
    type: EDIT_CONTENT_GROUP,
  };
}

function createContentGroupAction(payload, successMessage = "") {
  const { content, name } = payload;
  return {
    payload: {
      successMessage,
      serviceArgs: [name, content],
    },
    type: CREATE_CONTENT_GROUP,
  };
}

export {
  ARCHIVE_CONTENT_GROUPS_SUCCESS,
  CREATE_CONTENT_GROUP,
  CREATE_CONTENT_GROUP_ERROR,
  CREATE_CONTENT_GROUP_SUCCESS,
  createContentGroupAction,
  EDIT_CONTENT_GROUP,
  EDIT_CONTENT_GROUP_ERROR,
  EDIT_CONTENT_GROUP_SUCCESS,
  editContentGroupAction,
  LOAD_CONTENT_GROUPS,
  LOAD_CONTENT_GROUPS_FAILURE,
};
